import type { Team } from '~/vendor/cxy/types';

import { Tabs, TabsList, TabsTrigger } from '../Tabs';

import styles from './styles/BarChart.module.scss';
// Re-exported, not redeclared: this file and `util/types.ts` each had an identical copy, so the two
// could drift while every consumer type-checked against whichever it imported.
import type { FilterTypes } from './util/types';

export type { FilterTypes };

export type TabFilterProps = {
  customLabels?: Record<FilterTypes, string>;
  fullTabsWidth?: boolean;
  oppositionTeam?: Team;
  selectedFilterType: string;
  setSelectedFilterType: (value: string) => void;
  shouldShowVersusTab: boolean;
};

export const TabFilter = ({
  customLabels = { All: 'All', Home: 'Home', Away: 'Away', versus: 'vs' },
  fullTabsWidth = false,
  oppositionTeam,
  selectedFilterType,
  setSelectedFilterType,
  shouldShowVersusTab,
}: TabFilterProps) => (
  <Tabs className={styles.tabs} onValueChange={setSelectedFilterType} value={selectedFilterType}>
    <TabsList fullWidth={fullTabsWidth}>
      <TabsTrigger value="All">{customLabels.All}</TabsTrigger>
      <TabsTrigger value="Home">{customLabels.Home}</TabsTrigger>
      <TabsTrigger value="Away">{customLabels.Away}</TabsTrigger>
      {shouldShowVersusTab && oppositionTeam && (
        <TabsTrigger value="versus">
          {customLabels.versus} {oppositionTeam.shortName}
        </TabsTrigger>
      )}
    </TabsList>
  </Tabs>
);
